<template lang="pug">
.columns.align-center.col-gapless
  .column
    input.form-input(type="file" :disabled="loading" :class="{ loading }" @input="onInputFile" v-bind="inputAttrs")
  .column.col-auto(v-if="value")
    .popover.popover-left
      .btn.btn-primary.btn-auto.tooltip.tooltip-left(data-tooltip="Arquivo selecionado") #[i.fas.fa-check]
</template>

<script>
import upload from '@/services/upload'

export default {
  props: {
    value: { required: true },
    showPreview: { type: Boolean, default: true },
    inputAttrs: { type: Object, default: () => ({}) },
  },
  data() {
    return { loading: false }
  },
  methods: {
    async onInputFile(event) {
      const files = event.target.files || event.dataTransfer.files

      if (!files.length) return

      const file = files[0]

      this.$emit('input', file)
      const name = file.name
      const lastDot = name.lastIndexOf('.')

      const extension = name.substring(lastDot + 1)
      this.$emit('file-format-update', extension)
    },
  },
}
</script>

<style lang="stylus" scoped>
.btn-auto
  height 42px
  width 42px
  border-top-left-radius 0
  border-bottom-left-radius 0
  display flex
  align-items center
  justify-content center
</style>
